import { Paper, Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Select, MenuItem, Radio, Button,InputLabel } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";

const PointTopupDialog = ({ open, onClose, onFinish, user }) => {
  const [form, setForm] = useState({
    type: "PLUS", // 充值类型
    remark: "",
    amount: "",
    password: "",
    version: 1,
  });
  const [typeList, setTypeList] = useState([
    {
      id: 2,
      name: "绿积分2.0",
    },
    {
      id: 3,
      name: "锁仓积分",
    },
    {
      id: 4,
      name: "活动积分",
    },
    {
      id: 5,
      name: "文金通积分",
    },
    {
      id: 1,
      name: "绿积分1.0",
    },
  ]);
  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");

    const { msg } = await asyncRequest({
      path: "/user/changePointsV2",
      data: {
        uid: user.uid,
        ...form,
      },
    });

    alert(msg, "success");
    onFinish();
  }

  return (
    <FormDialog title="修改积分" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <UserInfo {...user} />
      </FormItem>

      <FormItem title="类型" required>
        {/* <RadioGroup row name="row-radio-buttons-group" value={form.version} onChange={(e) => handleIptChange("version", e.target.value)}>
          <FormControlLabel value={1} control={<Radio />} label="1.0" />
          <FormControlLabel value={2} control={<Radio />} label="2.0" />
        </RadioGroup> */}
        <Select
          label="请选择类型"
          row
          style={{ width: 200 }}
          value={form.version}
          onChange={(e) => handleIptChange("version", e.target.value)}
        >
          {typeList.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormItem>

      <FormItem title="变化" required>
        <RadioGroup row name="row-radio-buttons-group" value={form.type} onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={"PLUS"} control={<Radio />} label="增加" />
          <FormControlLabel value={"MINUS"} control={<Radio />} label="减少" />
          {/* <FormControlLabel value={'FINAL'} control={<Radio />} label="最终积分" /> */}
        </RadioGroup>
      </FormItem>

      <FormItem title="充值数目" required>
        <TextField fullWidth type="number" placeholder="充值数目" autoComplete="off" id="amount" value={user.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
      </FormItem>

      <FormItem title="备注" required>
        <TextField fullWidth multiline rows={4} placeholder="备注" autoComplete="off" id="remark" value={user.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default PointTopupDialog;
